var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-header"},[(_vm.title)?_c('h2',{staticClass:"level-3",domProps:{"innerHTML":_vm._s(_vm.title)}}):(_vm.$slots.default)?_c('h2',{staticClass:"level-3"},[_vm._t("default")],2):_vm._e(),(_vm.caption)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.caption)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }